import ReadingPaneOptionState from './schema/ReadingPaneOptionState';
import { createStore } from 'satcheljs';

export default createStore<ReadingPaneOptionState>('readingPaneOption', {
    readingPanePosition: null,
    nextSelection: null,
    loadMessageOnLogOn: null,
})();
